import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer as MuiDrawer } from '@material-ui/core';
import { compose, color, shadow, border, flexbox, space, layout } from 'styled-system';
import { getStyledFunctionsNames } from './utils';
import { withTheme } from 'emotion-theming';
var styledFunctions = {
  border: border,
  color: color,
  flexbox: flexbox,
  layout: layout,
  shadow: shadow,
  space: space
};

var Drawer = function Drawer(props) {
  var transitionDuration = props.transitionDuration,
      isOpen = props.isOpen,
      anchor = props.anchor,
      onClose = props.onClose,
      displayMode = props.displayMode,
      children = props.children,
      onEnter = props.onEnter;
  var classes = makeStyles({
    paper: _extends({}, compose.apply(void 0, _toConsumableArray(Object.values(styledFunctions)))(props))
  }, {
    name: 'Drawer'
  })();
  return React.createElement(MuiDrawer, {
    transitionDuration: transitionDuration,
    open: isOpen,
    anchor: anchor,
    onClose: onClose,
    variant: displayMode,
    PaperProps: {
      className: classes.paper
    },
    ModalProps: {
      onRendered: onEnter
    }
  }, children);
};

Drawer.defaultProps = {
  boxShadow: 100,
  bg: 'background',
  transitionDuration: 350,
  displayMode: 'temporary',
  p: [2, 3, 4],
  color: 'inherit'
};
Drawer.styledFunctions = getStyledFunctionsNames(styledFunctions);
export default withTheme(Drawer);